import { render, staticRenderFns } from "./FeatureAudienceDialog.vue?vue&type=template&id=2b3391d5"
import script from "./FeatureAudienceDialog.vue?vue&type=script&lang=js"
export * from "./FeatureAudienceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports